export const DEFAULT_CONTRACTOR_TYPES = [
  "Architectural", "Hydraulic", "Electrical", "Structural", "Fire",
];

export function buildDefaultContractors() {
  return DEFAULT_CONTRACTOR_TYPES.map((type) => ({
    type,
    is_default: true,
    not_needed: false,
    contacts: [],
  }));
}

export function mergeContractorsWithDefaults(contractors) {
  const byType = Object.fromEntries((contractors || []).map((contractor) => [contractor.type, contractor]));
  const result = DEFAULT_CONTRACTOR_TYPES.map((type) =>
    byType[type]
      ? { ...byType[type], is_default: true }
      : { type, is_default: true, not_needed: false, contacts: [] }
  );

  (contractors || []).forEach((contractor) => {
    if (!DEFAULT_CONTRACTOR_TYPES.includes(contractor.type)) {
      result.push(contractor);
    }
  });

  return result;
}
